module.exports = __webpack_public_path__ + "static/media/BikeSharing-retro2.631b2069.pdf";